import { StyledContainer } from "./styles";
import Modal from "react-modal";
import Auth from "../../../Auth";
import { useEffect, useState } from "react";
import IconButton from "../../IconButton";
import classNames from "classnames";

Modal.setAppElement("#root");

const customStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(55, 55, 55, 0.7)",
    zIndex: "100000001",
  },
  content: {
    top: "10%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    zIndex: "20000",
    width: "750px",
    transform: "translate(-50%, 0)",
    borderRadius: "15px",
    border: "0px",
    padding: "0px",
    background: "var(--menu-color-fullscreen)",
    boxShadow: "var(--default-drop-shadow)",
  },
};

export default function FeedbackModal({ open, feedbackInvocation, close, setRecentInvocations, recentInvocations, projectId }) {
  const [feedback, setFeedback] = useState("");
  const [enabled, setEnabled] = useState(true);
  const [success, setSuccess] = useState(false);

  const sendInvocationEvent = async () => {
    return await Auth.fetchWithIdToken("/api/invocationEvent", {
      events: [
        {
          invocationId: feedbackInvocation,
          eventType: "feedback",
          value: `Action: ${open} | InvocationId: ${feedbackInvocation} | Feedback: ${feedback} | ProjectId: ${projectId}`,
        },
      ],
    });
  };

  useEffect(() => {
    let timer;
    if (success) {
      // Set a timeout to close the modal after 2 seconds
      timer = setTimeout(() => {
        setEnabled(true);
        setFeedback("");
        setSuccess(false);
        close(); // This function should be the one provided to close the modal
      }, 2000);
    }

    // Cleanup function to clear the timer if the component unmounts before the timer finishes
    return () => clearTimeout(timer);
  }, [success, close]); // Dependencies array to re-run the effect when `success` or `close` changes

  const onSubmit = async (e) => {
    e.preventDefault();
    setEnabled(false);
    const res = await sendInvocationEvent();
    if (res.success) {
      setSuccess(true);
    }
    setRecentInvocations({ ...recentInvocations, lastInvocationType: null });
  };

  return (
    <Modal
      isOpen={open}
      // contentRef={(node) => (ref.current = node)}
      style={customStyles}
      onRequestClose={() => {
        setEnabled(true);
        setFeedback("");
        setSuccess(false);
        close();
      }}
    >
      <StyledContainer>
        <div className="header-container">
          <h2>Tell us more</h2>
          <IconButton
            src="/assets/close.svg"
            className="close"
            onClick={() => {
              setEnabled(true);
              setFeedback("");
              setSuccess(false);
              close();
            }}
          />
        </div>

        <br />

        <form onSubmit={(e) => onSubmit(e)}>
          <textarea
            onInput={(e) => setFeedback(e.target.value)}
            className="feedback-text"
            placeholder={`Why did you give this result a ${open === "like" ? "thumbs up" : "thumbs down"}?`}
          />
          <div className="footer-container">
            <div className={classNames("success", { hidden: !success })}>We have received your feedback. Thank you!</div>
            <button disabled={feedback.length > 5 && enabled ? false : true}>Send feedback</button>
          </div>
        </form>
      </StyledContainer>
    </Modal>
  );
}
